import configureStore from "./configureStore";
import rootSaga from "./rootSagas";
import rootReducer from "./rootReducer";

const { store, persistor } = configureStore(rootReducer, rootSaga);

export { store, persistor };
